module.exports = __webpack_public_path__ + "img/ceami_bg.e0a9a087.png";